import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable()
export class MentoringProvider {

    constructor(private http: HttpClient) {}

    getAvailableSkills(params: any): Observable<any> {
        return this.http.get(`${environment.envVar.API_URL}/skills`, {params}).pipe(
            map((data) => data)
        );
    }
}
